var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { API } from "./API";
import { getKlaviyoCustomerID } from "../utils/klaviyo";
import getGoogleAnalyticsParams from "../utils/getGoogleAnalyticsParams";
import updateRecentSearches from "../utils/updateRecentSearches";
import getShopifyVariant from "../utils/getShopifyVariant";
import getUserVariation from "../utils/ABTesting";
import { getBloomreachID } from "../utils/bloomreach";
import { getDotdigitalID } from "../utils/dotdigital";
const REPORT_BASE = "https://ping.fastsimon.com";
export var ReportingUpType;
(function (ReportingUpType) {
    ReportingUpType[ReportingUpType["popularSearchSeen"] = 1] = "popularSearchSeen";
    ReportingUpType[ReportingUpType["autocompleteProductSeen"] = 3] = "autocompleteProductSeen";
    ReportingUpType[ReportingUpType["searchPreformed"] = 4] = "searchPreformed";
    ReportingUpType[ReportingUpType["categorySearchSeen"] = 5] = "categorySearchSeen";
    ReportingUpType[ReportingUpType["relatedProductSeen"] = 15] = "relatedProductSeen";
    ReportingUpType[ReportingUpType["popUpUsedQuickView"] = 13] = "popUpUsedQuickView";
    ReportingUpType[ReportingUpType["popUpUsedLookALike"] = 17] = "popUpUsedLookALike";
    ReportingUpType[ReportingUpType["lookAlikeProductSeen"] = 18] = "lookAlikeProductSeen";
    ReportingUpType[ReportingUpType["collectionPreformed"] = 20] = "collectionPreformed";
    ReportingUpType[ReportingUpType["cartVisited"] = 9] = "cartVisited";
    ReportingUpType[ReportingUpType["searchPreformedNoResults"] = 8] = "searchPreformedNoResults";
    ReportingUpType[ReportingUpType["productAddedToCart"] = 9] = "productAddedToCart";
    ReportingUpType[ReportingUpType["relatedProductClicked"] = 12] = "relatedProductClicked";
    ReportingUpType[ReportingUpType["hoverOnProduct"] = 42] = "hoverOnProduct";
    ReportingUpType[ReportingUpType["hoverOnProductVariant"] = 43] = "hoverOnProductVariant";
    ReportingUpType[ReportingUpType["promoTileClicked"] = 44] = "promoTileClicked";
    ReportingUpType[ReportingUpType["landingPageSeen"] = 19] = "landingPageSeen";
    ReportingUpType[ReportingUpType["landingPageProductClicked"] = 25] = "landingPageProductClicked";
    ReportingUpType[ReportingUpType["collectionPreformedFromTurbolink"] = 46] = "collectionPreformedFromTurbolink";
})(ReportingUpType || (ReportingUpType = {}));
export var ReportingEndpoint;
(function (ReportingEndpoint) {
    ReportingEndpoint["Autocomplete"] = "post_load_ac";
    ReportingEndpoint["General"] = "post_load";
})(ReportingEndpoint || (ReportingEndpoint = {}));
export function Report(_a) {
    var _b;
    var { endpoint = ReportingEndpoint.General, params, upType } = _a, base = __rest(_a, ["endpoint", "params", "upType"]);
    let variation_id = getUserVariation();
    // delayed product from search report for products personalization
    updateRecentSearches(params);
    if ((window === null || window === void 0 ? void 0 : window.Shopify) && !(params === null || params === void 0 ? void 0 : params.variant_id)) {
        params = getShopifyVariant(params);
    }
    if ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.search) {
        params['qs'] = encodeURIComponent(window.location.search);
    }
    return API.get({
        url: `${REPORT_BASE}/${endpoint}`,
        params: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ source: "fast-simon-reporting" }, params), formatBase(base)), { prev_up_type: upType, kl_id: getKlaviyoCustomerID() }), getGoogleAnalyticsParams()), { doc_ref: document.referrer, variation_id: getUserVariation(), bloomreach_id: getBloomreachID(), dotdigital_id: getDotdigitalID() }),
    });
}
const formatBase = (base) => ({
    UUID: base.uuid,
    store_id: base.storeID,
    cart_token: base.cartToken,
    session: base.sessionToken.start,
    st: base.userSession,
    l: base.site ? window.location.host : undefined
});
//# sourceMappingURL=reporting.js.map